import {
    array,
    boolean,
    literal,
    nullable,
    number,
    object,
    optional,
    string,
    union,
} from "superstruct";

import { ATTRIBUTE_TYPE, REVIEWS_REPLY_STATUS } from "../constants";
import CustomerSchema from "./CustomerSchema";
import CustomFormQuestionSchema from "./CustomFormQuestionSchema";
import ReviewImagesSchema from "./ReviewImagesSchema";

export const ReviewCustomFormsSchema = object({
    answer: union([string(), number(), array(number())]),
    question: CustomFormQuestionSchema,
    questionId: number(),
    reviewId: number(),
});

// Text Filed
export const AttributeTextFieldContentAnswerSchema = object({
    type: literal(ATTRIBUTE_TYPE.TEXTFIELD),
    value: string(),
});

// Single Value
export const AttributeSingleValueContentAnswerSchema = object({
    type: literal(ATTRIBUTE_TYPE.SINGLE_VALUE),
    value: string(),
});

// Multi Value
export const AttributeMultiValueContentAnswerSchema = object({
    type: literal(ATTRIBUTE_TYPE.MULTI_VALUE),
    values: array(string()),
});

// Range
export const AttributeRangeContentAnswerSchema = object({
    type: literal(ATTRIBUTE_TYPE.RANGE),
    minLabel: string(),
    maxLabel: string(),
    value: number(),
});

// Centered Range
export const AttributeCentredRangeContentAnswerSchema = object({
    type: literal(ATTRIBUTE_TYPE.CENTERED_RANGE),
    minLabel: string(),
    midLabel: string(),
    maxLabel: string(),
    value: number(),
});

// Date
export const AttributeDateContentAnswerSchema = object({
    type: literal(ATTRIBUTE_TYPE.DATE),
    day: optional(number()),
    month: optional(number()),
    year: optional(number()),
});

// Location
export const AttributeLocationContentAnswerSchema = object({
    type: literal(ATTRIBUTE_TYPE.LOCATION),
    value: string(),
});

// Customer Attribute Answers
export const CustomerAttributeAnswersSchema = object({
    id: string(),
    commonQuestionId: string(),
    title: string(),
    propertyName: string(),
    content: union([
        AttributeSingleValueContentAnswerSchema,
        AttributeMultiValueContentAnswerSchema,
        AttributeDateContentAnswerSchema,
        AttributeLocationContentAnswerSchema,
        AttributeTextFieldContentAnswerSchema,
    ]),
});

// Product Attribute Answers
export const ProductAttributeAnswersSchema = object({
    id: string(),
    commonQuestionId: string(),
    title: string(),
    propertyName: string(),
    content: union([
        AttributeRangeContentAnswerSchema,
        AttributeCentredRangeContentAnswerSchema,
        AttributeSingleValueContentAnswerSchema,
        AttributeMultiValueContentAnswerSchema,
        AttributeTextFieldContentAnswerSchema,
    ]),
});

// Attribute Answers
export const AttributeAnswersSchema = union([
    array(CustomerAttributeAnswersSchema),
    array(ProductAttributeAnswersSchema),
]);

const ReviewSchema = object({
    id: number(),
    uid: string(),
    body: string(),
    createdAt: string(),
    customer: nullable(CustomerSchema),
    images: array(ReviewImagesSchema),
    product: nullable(
        object({
            id: number(),
            isDeleted: boolean(),
            isDraft: boolean(),
            unavailableProductToken: nullable(string()),
        })
    ),
    rating: number(),
    title: nullable(string()),
    isPublished: boolean(),
    votes: number(),
    shopName: string(),
    reply: nullable(
        object({
            body: string(),
            status: union([
                literal(REVIEWS_REPLY_STATUS.PUBLIC),
                literal(REVIEWS_REPLY_STATUS.PRIVATE),
            ]),
        })
    ),
    isCustomerVoted: boolean(),
    isCustomerAuthor: boolean(),
    isPinned: boolean(),
    isIncentivized: boolean(),
    isImported: boolean(),
    customerAttributeAnswers: array(CustomerAttributeAnswersSchema),
    productAttributeAnswers: array(ProductAttributeAnswersSchema),
});

export default ReviewSchema;
